import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import authService from '../../services/AuthService';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class MetricsAssessment extends Component {

    constructor(props) {
        super(props);

        this.state = {
            asdClinicianDiagnoses: 0,
            asdClinicianDiagnosisYes: 0,
            asdClinicianDiagnosisNo: 0,
            asdNonClinicianDiagnoses: 0,
            asdNonClinicianDiagnosisYes: 0,
            asdNonClinicianDiagnosisNo: 0,
            asdClinicianCorrelation: 0,
            asdNonClinicianCorrelation: 0
        }
    }

    componentDidMount = () => {
        let url = "admin/assessmentmetrics";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                this.setState({
                    asdClinicianDiagnoses: response.data.asdClinicianDiagnoses,
                    asdClinicianDiagnosisYes: response.data.asdClinicianDiagnosisYes,
                    asdClinicianDiagnosisNo: response.data.asdClinicianDiagnosisNo,
                    asdNonClinicianDiagnoses: response.data.asdNonClinicianDiagnoses,
                    asdNonClinicianDiagnosisYes: response.data.asdNonClinicianDiagnosisYes,
                    asdNonClinicianDiagnosisNo: response.data.asdNonClinicianDiagnosisNo,
                    asdClinicianCorrelation: response.data.asdClinicianCorrelation,
                    asdNonClinicianCorrelation: response.data.asdNonClinicianCorrelation
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            this.setState({ showErrorAlert: true });
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        return (

            <Fragment>
                <h4>Usage Summary</h4>
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            <h4 className="metrics_heading">Clinical ASD Diagnosis</h4>
                            <Row>
                                <Col sm={8}>
                                    Total Assessments with Clinical Diagnosis
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdClinicianDiagnoses}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Total ASD Yes
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdClinicianDiagnosisYes}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Total ASD No
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdClinicianDiagnosisNo}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Correlation with CADE
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdClinicianCorrelation * 100}%
                                </Col>
                            </Row>
                            
                        </Col>
                        
                        <Col sm={6}>
                            <h4 className="metrics_heading">Educational ASD Diagnosis</h4>
                            <Row>
                                <Col sm={8}>
                                    Total Assessments with Educational Diagnosis
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdNonClinicianDiagnoses}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Total ASD Yes
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdNonClinicianDiagnosisYes}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Total ASD No
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdNonClinicianDiagnosisNo}
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={8}>
                                    Correlation with CADE
                                </Col>
                                <Col sm={4}>
                                    {this.state.asdNonClinicianCorrelation * 100}%
                                </Col>
                            </Row>
                            
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default MetricsAssessment;


// WEBPACK FOOTER //
// ./src/components/AdminHome/metricsAssessment.js